import { render, staticRenderFns } from "./DPI.vue?vue&type=template&id=69a2c256&scoped=true&"
import script from "./DPI.vue?vue&type=script&lang=js&"
export * from "./DPI.vue?vue&type=script&lang=js&"
import style0 from "./DPI.vue?vue&type=style&index=0&id=69a2c256&lang=scss&scoped=true&"
import style1 from "./DPI.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a2c256",
  null
  
)

export default component.exports